import type { CaptureResult } from "posthog-js";

// The query string on these pages is a credential: the activation/password-reset
// token on /activate and the OAuth code/state on the callbacks.
const SECRET_QUERY = /(\/(?:activate|oauth\/[^/?#]+\/callback))\?[^#]*/g;

// Heatmaps, web vitals and replay nest location.href (heatmaps even as an
// object key), so walk every value and key in place.
function scrub(value: unknown): unknown {
  if (typeof value === "string") return value.replace(SECRET_QUERY, "$1");
  if (value && typeof value === "object") {
    const obj = value as Record<string, unknown>;
    for (const key of Object.keys(obj)) {
      const clean = scrub(key) as string;
      const scrubbed = scrub(obj[key]);
      if (clean !== key) delete obj[key];
      obj[clean] = scrubbed;
    }
  }
  return value;
}

// PostHog copies location.href into $current_url, into $initial_current_url
// on the person, and into the nested payloads above.
export function scrubSecretUrls(event: CaptureResult) {
  for (const props of [event.properties, event.$set, event.$set_once])
    if (props) scrub(props);
  return event;
}
